import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/components/EnvProvider/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/web/styled-system/styles.css");
;
import(/* webpackMode: "eager", webpackExports: ["WebReactQueryProvider"] */ "/vercel/path0/features/src/provider/react-query-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpeedInsights"] */ "/vercel/path0/node_modules/.pnpm/@vercel+speed-insights@1.0.11_next@15.5.0_@babel+core@7.28.3_@opentelemetry+api@1.9.0_r_a54bec39c72e19e9029da93e146665bc/node_modules/@vercel/speed-insights/dist/next/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["BunjaStoreProvider"] */ "/vercel/path0/node_modules/.pnpm/bunja@2.0.0-alpha.9_@types+react@19.0.2_react@19.0.0/node_modules/bunja/dist/react.js");
;
import(/* webpackMode: "eager", webpackExports: ["FiberProvider"] */ "/vercel/path0/node_modules/.pnpm/react-bunja-devtools@0.0.2_@types+react-reconciler@0.32.1_@types+react@19.0.2__@types+r_2d96856e3b6c3ff36309f11dc645ea1d/node_modules/react-bunja-devtools/dist/fiber/provider.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/packages/react/dist/css/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["JotaiProvider"] */ "/vercel/path0/packages/react/dist/providers/jotai.js");
;
import(/* webpackMode: "eager", webpackExports: ["RouteProvider"] */ "/vercel/path0/packages/react/dist/providers/route.js");
